<script lang="ts" module>
  export type BreadcrumbConfig = {
    width?: 'narrow' | 'medium' | 'full'
    compact?: boolean
    crumbs: Crumb[]
  }
  export type Crumb = {
    name: string
    href?: string
  }
</script>

<script lang="ts">
  import { resolve } from '$app/paths'
  import { page } from '$app/state'
  import Icon from '~icons/tabler/map-pin'
  interface Props {
    crumbs?: Crumb[] | undefined
  }

  let { crumbs = undefined }: Props = $props()

  let c = $derived(crumbs ?? page.data.breadcrumb?.crumbs)

  let width = $derived(page.data.breadcrumb?.width ?? 'medium')
  let compact = $derived(page.data.breadcrumb?.compact)
</script>

{#if c}
  <section class="@section +{width}" class:compact>
    <nav class="breadcrumbs">
      <ul>
        <li class="root"><Icon /></li>
        {#each c as crumb, i (i)}
          <li>
            {#if crumb.href}
              <a href={resolve(crumb.href as '/')}>{crumb.name}</a>
            {:else}
              <span>{crumb.name}</span>
            {/if}
          </li>
        {/each}
      </ul>
    </nav>
  </section>
{/if}

<style lang="postcss">
  section {
    padding-top: fluid(1.5rem, 3rem, 480px, 1128px);
    padding-bottom: 0;
    &.compact {
      padding-top: 1rem;
    }
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 0;
    padding: 0;
    font-size: var(--scale-00);
    list-style: none;
    .root {
      :global(svg) {
        display: block;
      }
    }
    & li {
      display: block;
      &:not(:first-child):before {
        display: inline-block;
        margin-inline: 0.5rem;
        content: '›';
      }
    }
  }
</style>
